import { render, staticRenderFns } from "./NotificationTemplateItem.vue?vue&type=template&id=bac909ce&scoped=true"
import script from "./NotificationTemplateItem.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplateItem.vue?vue&type=style&index=0&id=bac909ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac909ce",
  null
  
)

export default component.exports